import { ReservationDto } from '@wwt/entities/api/search-response'

import { useCustomerInformation } from '../../model/useCustomerInformation'
import { GuestInformationGrid } from './GuestInformationGrid'
import { GuestInformationGridElement } from './GuestInformationGridElement'

interface CustomerInformation {
	reservation: ReservationDto
}

const CustomerInformation = ({ reservation }: CustomerInformation) => {
	const customerInfo = useCustomerInformation(reservation)

	return (
		<div className="flex flex-col gap-y-3">
			<GuestInformationGrid>
				{customerInfo.map(element => (
					<GuestInformationGridElement
						key={element.id}
						title={element.title}
						content={element.content}
					/>
				))}
			</GuestInformationGrid>
		</div>
	)
}

export default CustomerInformation
